// client/src/routes/admin/admin-audit.tsx — „Audit admin" · D-2550.
//
// The platform administrator's own journal, beside „Jurnal de audit". Gated once by `/admin`'s
// layout route, like its siblings.

import { createFileRoute } from '@tanstack/react-router';

import { PlatformAdminJournalScreen } from '@/features/platform/PlatformAdminJournalScreen';

export const Route = createFileRoute('/admin/admin-audit')({
  component: PlatformAdminJournalScreen,
});
